<script>
    import app from "./stores/app";
    import user from "./stores/user";
    import groups from "./stores/groups";
    import members from "./stores/members";
    import app_alert from "./stores/alerts";
    import {countSmsLength, countMobiles, removeDoubleEntries, JSONClone} from "./lib/lib";
    import {loadSms} from "./requests";
    import {onMount} from 'svelte/internal';
    import InputOriginator from './InputOriginator.svelte';
    import CheckboxControl from './controls/CheckboxControl.svelte';
    import Groups from './Groups.svelte';
    import Members from "./members/Members.svelte";
    import MessageConfirm from './MessageConfirm.svelte';
    import {GROUP_TYPE} from "./lib/constants";

    export let sms_id = 0;

    let emptyMessage = {
        originator: $user.originator,
        sms: "",
        mobiles: "",
        scheduledon: "",
        total_recipients: 0,  // number of mobiles on selected groups + textarea
        groups: [],
        members: [],
        schedule_date: null,
        schedule_time: null,
    }
    let message = Object.assign({}, emptyMessage);

    let showConfirm = false; // MessageConfirm
    let groupsVisible = $app.device !== 'xs';
    let membersVisible = false;
    let isValid = false;
    let smsLength = 0;
    let totalGroupsRecipients = 0; // number of mobiles on selected groups
    let totalMembersRecipients = 0; // number of selected members
    let totalSmsRecipients = 0; // number of mobiles in textarea
    let originatorValid;

    let scheduleOnDate = false;

    let smsError = "";
    let recipientsError = "";
    let scheduleError = "";

    const openConfirm = () => {
        smsError = "";
        recipientsError = "";
        scheduleError = "";

        if (message.sms.length === 0) {
            smsError = "Δεν έχετε γράψει το μήνυμά σας!";
            return;
        }
        if (+message.total_recipients < 1) {
            recipientsError = "Δεν έχετε ορίσει παραλήπτες για το μήνυμά σας.";
            return;
        }
        if (scheduleOnDate && !message.schedule_date) {
            scheduleError = "Δεν έχετε ορίσει την ημερομηνία αποστολής του μηνύματος";
            return;
        } else if (scheduleOnDate && !message.schedule_time) {
            scheduleError = "Δεν έχετε ορίσει την ώρα αποστολής του μηνύματος";
            return;
        }
        showConfirm = true;
    }

    const closeConfirm = () => {
        showConfirm = false;
        resetMessage();
    }

    const cancelConfirm = () => {
        showConfirm = false;
    }

    const clearMessage = () => {
        app_alert.show('confirm', 'Θέλετε καθαρίσετε το μήνυμα;', resetMessage);
    }

    const resetMessage = () => {
        message = Object.assign({}, emptyMessage);
        groups.unselectGroups();
        members.unselectMembers();
        totalGroupsRecipients = 0;
        totalMembersRecipients = 0;
        totalSmsRecipients = 0;
    }

    const setScheduleDate = (event) => {
        message.schedule_date = event.target.value;
        scheduleError = "";
    }

    const setScheduleTime = (event) => {
        message.schedule_time = event.target.value;
        scheduleError = "";
    }

    const countRecipients = () => {
        totalGroupsRecipients = 0;
        $groups.list.map(group => {
            if (group.type == GROUP_TYPE.GROUP_MOBILES && group.selected) {
                if (group.total_mobiles) {
                    totalGroupsRecipients += parseInt(group.total_mobiles);
                }
            }
        });

        totalMembersRecipients = message.members.length;
        totalSmsRecipients = countMobiles(message.mobiles);
    }

    const mobilesKeyUp = (event) => {
        if (event.key === 'Enter' || event.key === ',') {
            countRecipients();
        }
    }

    const handleGroupToggle = ({detail: group}) => {
        let position = message.groups.indexOf(group.id);
        if (position > -1) {
            message.groups.splice(position, 1);
        } else {
            message.groups = [...message.groups, group.id];
        }
        countRecipients();
    }


    const handleMemberToggle = ({detail}) => {
        message.members = [];
        detail.map(member => {
            message.members.push(member.id);
        })
        countRecipients();
    }

    const toggleGroups = () => {
        if ($app.device === 'xs') {
            groupsVisible = !groupsVisible;
            membersVisible = false;
        } else if (!groupsVisible) {
            groupsVisible = true;
            membersVisible = false;
        }
    }

    const toggleMembers = () => {
        if ($app.device === 'xs') {
            membersVisible = !membersVisible;
            groupsVisible = false;
        } else if (!membersVisible) {
            membersVisible = true;
            groupsVisible = false;
        }
    }


    onMount(async () => {
        if (sms_id > 0) {
            const [err, res] = await loadSms(sms_id);

            if (err) {
                message = JSONClone(emptyMessage);
                return;
            }

            message = {
                originator: res.originator,
                sms: res.sms,
                mobiles: res.mobiles,
                scheduledon: "",
                total_recipients: 0,  // number of mobiles on selected groups, members + textarea
                groups: res.groups ? res.groups : [],
                members: res.members ? res.members : [],
            };

            groups.selectGroups(message.groups);
            members.selectMembers(message.members);

            countRecipients();
        } else {
            resetMessage();
        }
    });

    $: {
        isValid = originatorValid;
        smsLength = countSmsLength(message.sms);

        message.total_recipients = totalGroupsRecipients + totalMembersRecipients + totalSmsRecipients;
        removeDoubleEntries(message.mobiles);
        if (!scheduleOnDate) {
            scheduleError = "";
            message.schedule_date = null;
            message.schedule_time = null;
        }
    }

</script>
<div class="page-header">
    <div class="page-title">{ sms_id == 0 ? 'Νέο Μήνυμα' : 'Επανάληψη Αποστολής' }</div>
    <div class="controls">
        <div title="Εκκαθάριση μηνύματος" on:click|preventDefault="{ clearMessage }">
            <span class="icon"><i class="fa fa-file-o"></i></span>
            <span class="caption">Νέο μήνυμα</span>
        </div>
        <div title="Εμφάνιση ομάδων" on:click|preventDefault="{ toggleGroups }">
            <span class="icon"><i class="fa fa-users"></i></span>
            <span class="caption">Ομάδες</span>
        </div>
        <div title="Εμφάνιση επαφών" on:click|preventDefault="{ toggleMembers }">
            <span class="icon"><i class="fa fa-address-card-o"></i></span>
            <span class="caption">Επαφές</span>
        </div>
    </div>
</div>

<div class="page">
    <div class="page-main shrinked">
        <div class="content">

            <div class="panel mrg-b-sm">
                <div class="panel-body">
                    <div class="form-group">
                        <label>ΑΠΟΣΤΟΛΕΑΣ</label>
                        <InputOriginator bind:originator="{ message.originator }"
                                         bind:isValid="{ originatorValid }"/>
                    </div>
                    <CheckboxControl label="Προγραμματισμός αποστολής" bind:checked="{ scheduleOnDate }"/>
                    {#if scheduleOnDate}
                        <label>ΑΠΟΣΤΟΛΗ</label>
                        <div class="row">
                            <div class="col-md-6 col-xs-6">
                                <div class="form-group">
                                    <input type="date" on:change="{ setScheduleDate }" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4 col-xs-6">
                                <div class="form-group mrg-b-none">
                                    <input type="time" on:change="{ setScheduleTime }" class="form-control">
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if scheduleError}
                        <div class="alert alert-danger mrg-b-none">{ scheduleError }</div>
                    {/if}
                </div>
            </div>

            <div class="panel mrg-b-sm">
                <div class="panel-body">
                            <textarea style="min-width: 100%; max-width: 100%;" bind:value="{ message.sms }"
                                      on:keyup="{ () => smsError = '' }" class="form-control " rows="5"
                                      placeholder="μήνυμα"></textarea>
                    <p class="text-small mrg-b-none" class:text-danger={ smsLength> 160 }>
                        {#if smsLength > 160 }<i class="fa fa-exclamation-triangle"></i>{/if}
                        { smsLength ? smsLength + " / 160 χαρακτήρες" : "" }
                    </p>
                    {#if (smsError)}
                        <div class="alert alert-danger mrg-b-none">{ smsError }</div>
                    {/if}
                </div>
            </div>

            <div class="panel mrg-b-sm">
                <div class="panel-heading panel-heading-sm">
                    ΠΑΡΑΛΗΠΤΕΣ:
                    {#if message.total_recipients}
                        <span class="total-recipients"> {  message.total_recipients } </span>
                        <div class="subtitle">
                            {#if totalSmsRecipients > 0}
                                { totalSmsRecipients } κινητά
                            {/if}
                            {#if totalGroupsRecipients > 0}
                                { totalGroupsRecipients } από ομάδες
                            {/if}
                            {#if totalMembersRecipients > 0}
                                { totalMembersRecipients } επαφές
                            {/if}
                        </div>
                    {/if}
                </div>
                <div class="panel-body">
                    <p class="text-small mrg-t-none">Εισάγετε τα κινητά τηλέφωνα χωρισμένα με <span class="text-info">κόμμα</span> ή <span class="text-info">Enter</span></p>
                    <textarea bind:value="{ message.mobiles }" on:blur="{ countRecipients }"
                              on:keyup="{ mobilesKeyUp }"
                              on:keyup="{ () => recipientsError = '' }"
                              class="form-control message-recipient-mobiles"
                              style="min-width: 100%; max-width: 100%;" rows="8"></textarea>
                    {#if (recipientsError)}
                        <div class="alert alert-danger mrg-t-md mrg-b-none">{ recipientsError }</div>
                    {/if}
                </div>
            </div>

            <button class="btn btn-success btn-lg btn-block mrg-b-md" on:click="{ openConfirm }"
                    disabled="{ !isValid }">
                ΑΠΟΣΤΟΛΗ
                ΜΗΝΥΜΑΤΟΣ
            </button>
        </div> <!-- /content -->
    </div> <!-- /page-main -->

    <div class="page-side" class:collapsed={ !groupsVisible }>
        <Groups on:toggle="{ handleGroupToggle }" callback="{ toggleGroups }"/>
    </div>
    <div class="page-side" class:collapsed={ !membersVisible }>
        <Members on:change="{ handleMemberToggle }" on:close={ () => membersVisible = false }/>
    </div>


</div> <!-- /page -->

<MessageConfirm message="{ message }" showConfirm="{ showConfirm }" on:close="{ closeConfirm }"
                on:cancel="{ cancelConfirm }"/>

